import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { array, object, string } from "prop-types";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import Row1 from "./Row1";
import Row2LeftColumn from "./Row2LeftColumn";
import Row2RightColumn from "./Row2RightColumn";
import DfpAd from "../../dfp-ad";

import { getCollectionName, getSlug } from "../../utils/utils";

import "./fourteenStories3Ad1Widget.m.css";

const FourteenStories3Ad1Widget = ({ collection, sections, domainSlug, lang, pageType }) => {
  const stories =
    collection.items && collection.items.length > 0 && collection.items.filter((item) => item.type === "story");

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");
  const adSlotId3 = get(collection, ["associated-metadata", "ad_slot_id3"], "default_ad_slot3");
  const widgetUrl = get(collection, ["associated-metadata", "widget_url"], null);
  const show13Story = get(collection, ["associated-metadata", "show_13_story"], true);

  const bannerImg = get(collection, ["associated-metadata", "banner_img"], null);
  const bannerClick = get(collection, ["associated-metadata", "banner_click"], null);
  if (!stories.length) {
    return null;
  }

  return stories.length > 1 ? (
    <div styleName="base">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionSlug={collectionSlug} collectionName={collectionName} />
      )}
      <div styleName="wrapper">
        <Row1
          stories={stories.slice(0, 2)}
          collectionSlug={collectionSlug}
          adSlotId2={adSlotId2}
          widgetUrl={widgetUrl}
          lang={lang}
          pageType={pageType}
        />
        <Row2LeftColumn stories={stories.slice(2, 11)} />
        <Row2RightColumn
          stories={stories.slice(11, 13)}
          bannerImg={bannerImg}
          bannerClick={bannerClick}
          show13Story={show13Story}
        />
      </div>
      <div styleName="b1_ad">
        <div styleName="inner_ads">
          <DfpAd
            adtype={lang === "en" ? "EnPalo_HP_468x60_B1" : "Home_468x60_B1"}
            collectionSlug={collectionSlug}
            layoutName="HomeFeatured"
            slotId={adSlotId3}
          />
        </div>
      </div>
    </div>
  ) : null;
};

FourteenStories3Ad1Widget.storyLimit = 13;

FourteenStories3Ad1Widget.propTypes = {
  collection: object.isRequired,
  sections: array,
  domainSlug: string,
  lang: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  pageType: get(state, ["qt", "pageType"]),
});

export default connect(mapStateToProps)(FourteenStories3Ad1Widget);
